import tw, { styled } from 'twin.macro';

const PreviewValue = styled.span`
  ${tw`text-core-secondary ml-1`}
`;

export default PreviewValue;
